<template>
  <v-row justify="center" dense>
    <v-col cols="12" sm="6" md="3">
      <v-select
        :items="transportTypes"
        item-text="name"
        item-value="id"
        v-model="contextTransportType"
        :error-messages="modelTransportTypeValidation"
        :label="$t('delegation.form.fields.transport.transportType.name')"
        :readonly="$store.state.Delegation.readonly === true"
        persistent-hint
        :hint="validationTransportType"
        :background-color="validationTransportType !== null ? 'blue lighten-5' : null"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3" v-if="modelTransportType !== 1">
      <v-select
        :items="settlementTypes(modelTransportType)"
        v-model="contextSettlementTypeId"
        :error-messages="modelSettlementTypeIdValidation"
        :label="$t('delegation.form.fields.transport.settlementType.name')"
        :readonly="$store.state.Delegation.readonly === true"
      />
    </v-col>
    <v-col cols="12" sm="6" md="2">
      <ajax-single-file
        :accept="$store.getters['Delegation/allowedAttachmentFileFormat']"
        :items="fileProperties"
        :model.sync="contextFileId"
        v-on:fileUploaded="addFileToDelegationFiles"
        v-on:fileRemoved="removeFileFromDelegationFiles"
        :validation-message="modelFileIdValidation"
        :readonly="$store.state.Delegation.readonly === true"
      />
    </v-col>
    <v-col cols="8" sm="4" md="2">
      <AmountInput :error-messages="modelAmountValidation" :model.sync="contextAmount" :readonly="$store.state.Delegation.readonly === true" />
    </v-col>
    <v-col cols="4" sm="2" md="2">
      <currency-select :model.sync="contextCurrency" :validation-message="modelCurrencyValidation" :readonly="$store.state.Delegation.readonly === true" />
    </v-col>
  </v-row>
</template>

<script>
import TransportTypes from "../../../../staticData/TransportTypes";
import SettlementTypes from "../../../../staticData/TransportSettlementTypes";
import CurrencySelect from "../../../CustomInputComponents/CurrencySelect.vue";
import AjaxSingleFile from "../../../CustomInputComponents/AjaxSingleFile.vue";
import AmountInput from "../../../CustomInputComponents/AmountInput.vue";
import ValidationTransportType from "./validationTransportType";

export default {
  name: "FirstRowTransportSettlementProvidesEmployerSet",
  components: { AjaxSingleFile, CurrencySelect, AmountInput },
  props: {
    modelTransportType: {
      required: true
    },
    modelSettlementTypeId: {
      required: true
    },
    modelFileId: {
      required: true
    },
    modelAmount: {
      required: true
    },
    modelCurrency: {
      required: true
    },
    modelTransportTypeValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelSettlementTypeIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelFileIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelCurrencyValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelAmountValidation: {
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: () => ({
    filePropertiesLocal: []
  }),
  computed: {
    validationTransportType: function() {
      return ValidationTransportType(this);
    },
    transportTypes: TransportTypes,
    contextTransportType: {
      set: function(value) {
        this.$emit("update:modelTransportType", value);
      },
      get: function() {
        return this.modelTransportType;
      }
    },
    contextSettlementTypeId: {
      set: function(value) {
        this.$emit("update:modelSettlementTypeId", value);
      },
      get: function() {
        return this.modelSettlementTypeId;
      }
    },
    contextAmount: {
      set: function(value) {
        this.$emit("update:modelAmount", value);
      },
      get: function() {
        return this.modelAmount;
      }
    },
    contextCurrency: {
      set: function(value) {
        this.$emit("update:modelCurrency", value);
      },
      get: function() {
        return this.modelCurrency;
      }
    },
    contextFileId: {
      set: function(value) {
        this.$emit("update:modelFileId", value);
      },
      get: function() {
        return this.modelFileId;
      }
    },
    fileProperties: {
      set: function(value) {
        this.filePropertiesLocal = value;
      },
      get: function() {
        if (this.filePropertiesLocal.length === 0) {
          const self = this;
          let temp = this.$store.getters["Delegation/delegationEdited"].file.find(function(element) {
            return element.id === self.contextFileId;
          });
          if (typeof temp !== "undefined") {
            return [temp];
          }
        }
        return [];
      }
    }
  },
  methods: {
    settlementTypes: SettlementTypes,
    addFileToDelegationFiles(item) {
      const newItem = item;
      newItem.description = "Skan biletu dotycząceo transportu";
      newItem.category = "transport";
      this.$store.dispatch("Delegation/addFile", newItem);
    },
    removeFileFromDelegationFiles(item) {
      this.$store.dispatch("Delegation/removeFile", item.id);
    }
  }
};
</script>

<style scoped></style>
